import {Editor, type EditorInterface} from '../interfaces/editor'
import {Node} from '../interfaces/node'

export const leaf: EditorInterface['leaf'] = (editor, at, options = {}) => {
  const path = Editor.path(editor, at, options)
  const node = Node.leaf(editor, path, editor.schema)
  return [node, path]
}
